class ScrollCarouselElement extends HTMLElement {
  connectedCallback() {
    this._track = this.querySelector('[data-ref="track"]');
    this._prev = this.querySelector('[data-ref="prev"]');
    this._next = this.querySelector('[data-ref="next"]');
    this._dots = this.querySelectorAll('[data-ref="dot"]');

    this.classList.add('scroll-carousel--enhanced');

    this._controller = new AbortController();
    const { signal } = this._controller;

    this._prev?.addEventListener('click', () => this._scrollByCard(-1), { signal });
    this._next?.addEventListener('click', () => this._scrollByCard(1), { signal });
    this._track.addEventListener('scroll', this._onScroll, { passive: true, signal });

    this._resizeObserver = new ResizeObserver(() => {
      this._updateEdgeInset();
      this._updateControls();
    });
    this._resizeObserver.observe(this);
    this._resizeObserver.observe(this._track);

    this._updateEdgeInset();
    this._updateControls();
  }

  disconnectedCallback() {
    this._controller?.abort();
    this._resizeObserver?.disconnect();
    cancelAnimationFrame(this._raf);
  }

  // Distance between successive card left edges: card width + the flex gap.
  get _slot() {
    const card = this._track.querySelector('.scroll-carousel__item');
    if (!card) {
      return this._track.clientWidth;
    }
    const gap = parseFloat(getComputedStyle(this._track).columnGap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  // The host is not part of the track's full-bleed breakout, so its left edge is
  // the content edge cards align to. Publishing it as --edge-inset lets the track
  // bleed correctly from any container, not just a page-width centered one.
  _updateEdgeInset() {
    this.style.setProperty('--edge-inset', `${this.getBoundingClientRect().left}px`);
  }

  _scrollByCard(direction) {
    this._track.scrollBy({ left: direction * this._slot, behavior: 'smooth' });
  }

  _onScroll = () => {
    cancelAnimationFrame(this._raf);
    this._raf = requestAnimationFrame(() => this._updateControls());
  };

  _updateControls() {
    const { scrollLeft, scrollWidth, clientWidth } = this._track;
    const max = scrollWidth - clientWidth;
    const scrollable = max > 1;

    this.classList.toggle('scroll-carousel--scrollable', scrollable);

    if (this._prev) this._prev.disabled = !scrollable || scrollLeft <= 1;
    if (this._next) this._next.disabled = !scrollable || scrollLeft >= max - 1;

    this._updateDots(scrollLeft);
  }

  _updateDots(scrollLeft) {
    if (!this._dots.length) {
      return;
    }
    const index = Math.round(scrollLeft / this._slot);
    this._dots.forEach((dot, i) =>
      dot.classList.toggle('scroll-carousel__dot--active', i === index)
    );
  }
}

customElements.define('chh-scroll-carousel', ScrollCarouselElement);

export default ScrollCarouselElement;
